/**
 * Convert server pending animation slots (absolute player ids) to viewer-relative
 * your_/opponent_ zones and your|opponent playerId — used by deploy + raid VFX.
 */
export function convertPendingAnimationForViewer(animationData, viewerUserId) {
  if (!animationData?.fromSlot || !animationData?.toSlot) {
    throw new Error('convertPendingAnimationForViewer: fromSlot and toSlot are required');
  }
  if (viewerUserId == null) {
    throw new Error('convertPendingAnimationForViewer: viewerUserId is required');
  }

  const fromPlayerId = String(animationData.fromSlot.playerId) === String(viewerUserId) ? 'your' : 'opponent';
  const toPlayerId = String(animationData.toSlot.playerId) === String(viewerUserId) ? 'your' : 'opponent';

  const fromZone = animationData.fromSlot.zone;
  const toZone = animationData.toSlot.zone;

  let fromZoneFull = fromZone === 'general'
    ? 'general'
    : (fromZone.startsWith('opponent_') || fromZone.startsWith('your_')
      ? fromZone
      : (fromPlayerId === 'your' ? `your_${fromZone}` : `opponent_${fromZone}`));

  if (fromZoneFull !== 'general') {
    if (fromPlayerId === 'your' && fromZoneFull.startsWith('opponent_')) {
      fromZoneFull = `your_${fromZoneFull.slice('opponent_'.length)}`;
    } else if (fromPlayerId === 'opponent' && fromZoneFull.startsWith('your_')) {
      fromZoneFull = `opponent_${fromZoneFull.slice('your_'.length)}`;
    }
  }

  let toZoneFull = toZone === 'general'
    ? 'general'
    : (toZone.startsWith('opponent_') || toZone.startsWith('your_')
      ? toZone
      : (toPlayerId === 'your' ? `your_${toZone}` : `opponent_${toZone}`));

  if (toZoneFull !== 'general') {
    if (toPlayerId === 'your' && toZoneFull.startsWith('opponent_')) {
      toZoneFull = `your_${toZoneFull.slice('opponent_'.length)}`;
    } else if (toPlayerId === 'opponent' && toZoneFull.startsWith('your_')) {
      toZoneFull = `opponent_${toZoneFull.slice('your_'.length)}`;
    }
  }

  const toSlotConverted = {
    ...animationData.toSlot,
    zone: toZoneFull,
    playerId: toPlayerId,
  };

  if (toZoneFull === 'opponent_drone' || toZoneFull === 'your_drone') {
    const droneIndex = animationData.toSlot.index;
    const droneEl = typeof document !== 'undefined' && document.querySelector(
      `[data-drone-zone="${toZoneFull}"][data-drone-index="${droneIndex}"]`
    );
    if (droneEl) {
      const rect = droneEl.getBoundingClientRect();
      toSlotConverted.cachedTargetPixel = {
        x: rect.left + rect.width / 2,
        y: rect.top + rect.height / 2,
      };
    }
  }

  return {
    ...animationData,
    fromSlot: {
      ...animationData.fromSlot,
      zone: fromZoneFull,
      playerId: fromPlayerId,
    },
    toSlot: toSlotConverted,
  };
}
